import React from "react";
import style from "./style.scss";

import { Button } from "../Button";

export const ButtonColumn = ({ children }) => {
    const buttons = React.Children.map(children, (child) => {
        if (child.type === Button) {
            return React.cloneElement(child, {
                className: style.button
            });
        }
    });

    return (
        <div className={style.base}>
            {buttons?.map((button, index) => (
                <div key={index} className={style.buttonWrapper}>
                    {button}
                </div>
            ))}
        </div>
    );
};
